/**
 * Logs exceptions with the server.
 *
 * This is for script loading errors etc, once jQuery and JSON are loaded the
 * full handler should be used.
 *
 *
 *
 * See: https://developer.mozilla.org/en/DOM/window.onerror
 *
 * Note: I have attempted to generate a stacktrace using
 *  https://raw.github.com/eriwen/javascript-stacktrace/master/stacktrace.js
 * but cannot get it to work without bugging out. I suspect try-catch falls
 * apart in the window.onerror global error handler.
 *
 * Note: this behaves wierd, I have tested it but some things seem to throw it
 * off, like having your console open/being in debugging mode. Needs testing
 * with typical browser setups.
 *
 *
 *
 * TODO: move files to /js/backend/error/....
 */

var logErrorWithServer = function(ex){

};

window.onerror = function(errorMsg, url, lineNumber){
	// Build error msg
	var err = 'Javascript Error (Basic Handler), message: '+errorMsg+', url: '+url+', lineNumber: '+lineNumber;

	// Log
	logErrorWithServer(err);

	// Show error message
	if(document && document.body && document.body.className && document.body.className.indexOf('display-errors') != -1){
		// environment with display-errors on
		console.error('window.onerror (Basic Handler): ', errorMsg, url, lineNumber);
	}else{
		// environment with display-errors off
		window.location.href = '/error/msg?javascript&handler=basic';
	}

	// Allow default browser handling of uncaught exceptions
	return false;
};
